export default "__VITE_ASSET__DJDCud_A__"